import EmployeeCard from './EmployeeCardContainer';

export default EmployeeCard;
